module.exports = __webpack_public_path__ + "img/team-map-04.8586c23a.png";